(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var mainBtn = document.querySelector('.product-form__submit[type="submit"]');
    if (!mainBtn) return;
    var stickyBar = document.getElementById('soan-sticky-atc');
    if (!stickyBar) return;
    var stickyBtn = document.getElementById('soan-sticky-atc-btn');
    var stickyPrice = document.getElementById('soan-sticky-atc-price');
    var qtyInput = document.getElementById('soan-sticky-qty');
    var qtyMinus = document.getElementById('soan-sticky-qty-minus');
    var qtyPlus = document.getElementById('soan-sticky-qty-plus');

    // Toast
    function showToast(msg, type) {
      var toast = document.getElementById('soan-sticky-toast');
      if (!toast) return;
      toast.textContent = msg;
      toast.className = 'soan-sticky-toast soan-sticky-toast--' + (type || 'success') + ' soan-sticky-toast--visible';
      clearTimeout(toast._t);
      toast._t = setTimeout(function() {
        toast.classList.remove('soan-sticky-toast--visible');
      }, 3000);
    }

    // Quantité
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Affiche/masque selon visibilité du bouton principal
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          var rect = mainBtn.getBoundingClientRect();
          if (rect.top < 0) {
            stickyBar.classList.add('soan-sticky-atc--visible');
          } else {
            stickyBar.classList.remove('soan-sticky-atc--visible');
          }
        } else {
          stickyBar.classList.remove('soan-sticky-atc--visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(mainBtn);

    // Clic sticky → remonte vers le bouton ATC principal
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Légère mise en avant du bouton principal
        setTimeout(function() {
          mainBtn.style.transition = 'box-shadow 0.3s ease';
          mainBtn.style.boxShadow = '0 0 0 3px #C9A84C';
          setTimeout(function() {
            mainBtn.style.boxShadow = '';
          }, 1500);
        }, 600);
      });
    }

    // Mise à jour prix sur changement variante
    document.addEventListener('variant:change', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      if (stickyPrice) stickyPrice.textContent = (v.price / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
    });
  });
})();
